/**
 * @generated SignedSource<<f2d435e6f2e222b3ad84b5134738ead2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerChatRespLazy_viewer">;
  readonly " $fragmentType": "PdpRespDealerChatLoader_viewer";
};
export type PdpRespDealerChatLoader_viewer$key = {
  readonly " $data"?: PdpRespDealerChatLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerChatLoader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isInteractivePdpChat"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerChatLoader_viewer",
  "selections": [
    {
      "condition": "isInteractivePdpChat",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyerChatRespLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f5caa6611dea338209c115e942db33c4";

export default node;
